import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const MissionVisionSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="py-16 lg:py-20 bg-slate-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={containerVariants}
          className="space-y-16">
          
          {/* Header */}
          <motion.div variants={itemVariants} className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-jakarta font-bold text-[#000150] leading-[1.1]">
              Mission & Vision
            </h2>
          </motion.div>

          {/* Mission & Vision Cards */}
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Mission */}
            <motion.div 
              variants={itemVariants}
              whileHover={{ scale: 1.02 }}
              className="bg-white p-12 rounded-3xl shadow-xl border border-gray-200">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-cyan-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <Icon name="Target" size={32} className="text-cyan-600" />
                </div>
                <div className="space-y-4">
                  <h3 className="text-3xl font-jakarta font-bold text-[#000150]">
                    Our Mission
                  </h3>
                  <p className="text-xl text-gray-700 leading-relaxed">
                    To make roofing fair, transparent, and affordable without sacrificing quality.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    We believe homeowners shouldn't have to choose between quality and affordability. By removing unnecessary overhead, we deliver both.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Vision */}
            <motion.div 
              variants={itemVariants}
              whileHover={{ scale: 1.02 }}
              className="bg-gradient-to-br from-blue-900 to-slate-900 p-12 rounded-3xl shadow-xl text-white">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-cyan-500/20 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <Icon name="TrendingUp" size={32} className="text-cyan-400" />
                </div>
                <div className="space-y-4">
                  <h3 className="text-3xl font-jakarta font-bold">
                    Our Vision
                  </h3>
                  <p className="text-xl text-gray-200 leading-relaxed">
                    To become the new standard for how roofing is bought, priced, and installed nationwide.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    We're not just building a company — we're creating a category. Openbooq roofing will be the expectation, not the exception.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MissionVisionSection;